export default __webpack_public_path__ + "static/kotler-da39f4f8ff4fe783a07d28ffd4ab2189.gif";